/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresentSessionRequest
 */
export interface PresentSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof PresentSessionRequest
     */
    sessionId: string;
}

/**
 * Check if a given object implements the PresentSessionRequest interface.
 */
export function instanceOfPresentSessionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sessionId" in value;

    return isInstance;
}

export function PresentSessionRequestFromJSON(json: any): PresentSessionRequest {
    return PresentSessionRequestFromJSONTyped(json, false);
}

export function PresentSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentSessionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
    };
}

export function PresentSessionRequestToJSON(value?: PresentSessionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sessionId': value.sessionId,
    };
}

